import { useQuery } from "react-query";
import { useSkillApi } from "./Skill.api";

export function useGetSkills() {
  const { getSkills } = useSkillApi();

  return useQuery({
    queryKey: ["skills"],
    queryFn: getSkills,
  });
}
